import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useFormContext, Controller } from 'react-hook-form'
import { useTranslate } from 'react-admin'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import 'dayjs/locale/es'
import get from 'lodash/get'
import dayjs from 'dayjs'

export const DatePickers = ({
  label,
  source,
  disabled,
  minDate,
  maxDate,
  showDay = true,
  showMonth = true,
  showYear = true,
  viewsShow = true,
  required = false,
  defaultValue = null,
  extraOnChange = null,
  displayBlock = false
}) => {
  const translate = useTranslate()
  const [error, setError] = useState('')
  const { control } = useFormContext()

  const getViews = () => {
    const views = []
    if (showDay) {
      views.push('day')
    }
    if (showMonth) {
      views.push('month')
    }
    if (showYear) {
      views.push('year')
    }

    return views
  }

  const getInputFormat = () => {
    const format = []
    if (showDay) {
      format.push('DD')
    }
    if (showMonth) {
      format.push('MM')
    }
    if (showYear) {
      format.push('YYYY')
    }

    return format.join('/')
  }

  return (
    <Controller
      control={control}
      name={source}
      defaultValue={defaultValue !== undefined ? defaultValue : ''}
      rules={{ required: required ? 'Requerido' : false }}
      render={({ field: { onChange, value, ref, name }, formState: { errors } }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
          <DatePicker
            className='datePicker'
            views={viewsShow ? getViews() : undefined}
            inputFormat={getInputFormat()}
            disabled={disabled}
            onChange={(e) => {
              const adjusted = dayjs(e).hour(12).minute(0).second(0);
              onChange(adjusted)
              if (extraOnChange) extraOnChange(adjusted) 
            }}
            value={value || null}
            label={label}
            renderInput={(params) => {
              const errorText = get(errors, name)?.message || error
              return (
                <div style={{ 
                    position: 'relative', 
                    display: displayBlock ? 'block' : 'inline-block', // Condición para display
                  }}>
                  <TextField
                    {...params}
                    error={Boolean(errorText)}
                    helperText={errorText}
                    style={{ width: '100%' }}
                  />
                  {value && (
                    <IconButton
                      onClick={() => onChange(null)}
                      style={{ position: 'absolute', top: '0', margin: 'auto', right: '11%' }}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                </div>
              )
            }}
            inputRef={ref}
            defaultCalendarMonth={minDate || maxDate}
            minDate={minDate}
            maxDate={maxDate}
            onError={(e) => {
              if (e === null) return setError('')
              if (e === 'minDate' || e === 'minTime') return setError(translate('ra.validation.date_min'))
              if (e === 'maxDate' || e === 'maxTime') return setError(translate('ra.validation.date_max'))
              if (e === 'invalidDate') return setError(translate('ra.validation.date_invalid'))
            }}
          />
        </LocalizationProvider>
      )}
    />
  )
}
